import createClient from 'openapi-fetch';
import { csrfMiddleware } from '../middleware';

type PublicPaths = {
  '/api/v1/public/venues/{venueId}/waivers/active-template': {
    get: {
      parameters: { path: { venueId: string } };
      responses: {
        200: {
          content: {
            'application/json': {
              templateId: string;
              version: number;
              bodyHtml: string;
              acknowledgements: Array<{ text: string; required: boolean }>;
            };
          };
        };
      };
    };
  };
  '/api/v1/public/venues/{venueId}/waivers': {
    post: {
      parameters: { path: { venueId: string } };
      requestBody: {
        content: {
          'application/json': {
            signerName: string;
            phone: string | null;
            email: string | null;
            participants: Array<{
              signerCapacity: 'SELF' | 'GUARDIAN_FOR_CHILD';
              childName: string | null;
              dateOfBirth: string | null;
            }>;
            signatureDataUrl: string;
          };
        };
      };
      responses: {
        201: {
          content: {
            'application/json': {
              signingBatchId: string;
              records: Array<{
                id: string;
                templateId: string;
                templateVersion: number;
                signerName: string;
                signerCapacity: 'SELF' | 'GUARDIAN_FOR_CHILD';
                childName: string | null;
                dateOfBirth?: string | null;
                phone: string | null;
                email: string | null;
                status: 'VALID' | 'EXPIRED' | 'REVOKED';
                capturedAt: string;
                expiresAt: string | null;
              }>;
            };
          };
        };
      };
    };
  };
};

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '/';

export const apiClient = createClient<PublicPaths>({
  baseUrl,
  credentials: 'include',
  fetch: (input) => globalThis.fetch(input),
});

apiClient.use(csrfMiddleware);
